import React from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { Clock } from "lucide-react";

const PendingApproval: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    Cookies.remove("token");
    navigate("/admin/login");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="w-full max-w-md rounded-lg bg-white p-8 text-center shadow-md">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-yellow-100">
          <Clock className="h-7 w-7 text-yellow-600" />
        </div>
        <h1 className="mb-2 text-2xl font-semibold text-gray-800">
          Awaiting Approval
        </h1>
        <p className="mb-6 text-gray-500">
          Your account has been created and your free trial has started, but
          you need approval from the master admin before you can use the POS.
          You'll be able to log in as soon as it's approved.
        </p>
        <button
          onClick={handleLogout}
          className="w-full rounded-md bg-gray-200 p-3 font-medium text-gray-700 transition hover:bg-gray-300"
        >
          Log out
        </button>
      </div>
    </div>
  );
};

export default PendingApproval;
